import React, { FC } from "react";

import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { StepComponentProps } from "@/components/organisms";
import { StyledHeaderTitleBase } from "@/styles/components";

import { CompanyFormType } from "../../formType";
import AddressForm from "./components/AddressForm/AddressForm";

const AddressStep: FC<StepComponentProps> = () => {
    const { t } = useTranslation();

    const { control } = useFormContext<CompanyFormType>();

    const { fields: addresses } = useFieldArray({
        control,
        name: "addresses",
    });

    return (
        <>
            <StyledHeaderTitleBase>{t("Common.Address")}</StyledHeaderTitleBase>
            {addresses.map((address, index) => (
                <AddressForm index={index} key={address.id} />
            ))}
        </>
    );
};

export default AddressStep;
